import React from "react";
import { connect } from "react-redux";
import { loadTabs } from "../../../Header/actions";
import TablaTrabajadores from "./trabajadores";
import { cleanState } from "./action";
import { push } from "connected-react-router";
import { checkAccess, ids, realCheckAccess } from "../../../../helpers/rolAccess";
import { paths } from "../../../../config/routes";

class TrabajadoresACHS extends React.Component {
  componentDidUpdate = (prevProps) => {
    /*if ((prevProps.userAccessIds === null && Array.isArray(this.props.userAccessIds))
      || this.props.currentHeader !== headerTitle) {*/
    this.loadTabs();
    // }
    if (prevProps.companyId !== this.props.companyId) {
      this.props.dispatch(push(paths.root))
    }
  }

  componentWillUnmount = () => {
    this.props.dispatch(cleanState())
  }

  loadTabs = () => {
    const tabs = [];

    if (checkAccess(ids.mantenedorGeneral, this.props.userAccessIds)) tabs.push({ text: "Gestionar roles ACHS", contentId: 0 });

    this.props.dispatch(loadTabs("Trabajadores ACHS", "", tabs, tabs.length ? tabs[0].contentId : null));
  }

  renderBody = () => {
    switch (this.props.selectedTab) {
      case 0:
        return <TablaTrabajadores />;
      default:
        return <div />;
    }
  }


  render() {
    return (
      <React.Fragment>
        {this.renderBody()}
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  selectedTab: state.header.contentId,
  isLoading: state.mantenedores.isLoading,
  companyId: state.global.companyId,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch: (action) => { dispatch(action); },
});

export default connect(mapStateToProps, mapDispatchToProps)(TrabajadoresACHS);
